import type { UserInfo, UserLogin } from "~/types/User"

export const useUserStore = defineStore('user', () => {
    const user = ref<UserInfo>()
    const userRepo = userRepository();

    function reset() {
        user.value = undefined
        
    }
    function setUser(userInfo: UserInfo) {
        user.value = userInfo
    }

    async function receiveUser() {
        try {
            const data = await userRepo.getUserInfo();
            // console.log(data.value);
            if (data !== null && data.code === 200) {
                setUser(data.data)
                return data.data
            } else {
                console.error('Failed to fetch user:', data.message);
            }
        } catch (reason) {
            console.error('Error during registration:', reason);
        }
    }

    async function updateUser(userInfo: UserInfo) {
        try {
            const data = await userRepo.updateUser(userInfo);
            if (data !== null && data.code === 200) {
                setUser(userInfo)
                return 'ok'
            } else {
                console.error('Failed to fetch user:', data.message);
                return 'Failed to fetch user: ' + data.message + ' ' + data.code
            }
        } catch (reason) {
            console.error('Error during registration:', reason);
            return 'Error during registration: ' + reason
        }
    }
    return {
        user,
        setUser,
        updateUser,
        receiveUser,
        reset
    }
})